import { convertBackendDataToRows } from "../../../utils/AgGridUtils/convertBackendDataToRows";

export function formDataToRow(groupedData) {
  return convertBackendDataToRows(groupedData, {
    groupKey: "theme",
    childrenKey: "sub_themes",

    getRowKey: (subTheme, groupItem) =>
      `${groupItem.id}-${groupItem.theme}-${subTheme.name}`,

    processRow: (row, subTheme, groupItem, key, rowMap) => {
      row.editable = true;
      row.title = "";

      const rowType = groupItem.theme.toLowerCase();
      const subThemeText = subTheme.name.toLowerCase();
      const isRejected = subThemeText.includes("rejected");
      const isYard = subThemeText.includes("yard");
      const isExcavator = subThemeText.includes("excavator");

      const tag = `${rowType}_${
        isRejected
          ? "rejected"
          : isYard
          ? "yard"
          : isExcavator
          ? "excavator"
          : "other"
      }`;

      row.tag = tag;

      if (rowType === "volumes") {
        if (isRejected) {
          row.format_to_ton = true;
          row.title = "Volume (Ton)";
        } else if (isYard) {
          row.title = "Volume (Hours) - 4hrs day / 4 trucks";
        } else if (isExcavator) {
          row.title = "Volume (Hours) - 12hrs day / 1 excavator";
        }
      } else {
        const isCost = rowType === "cost";
        row.title = isCost ? "Cost rate Rs/" : "Income rate Rs/";
        row.title += isRejected ? "T" : "H";

        // Add calculated row
        const subTitle = isCost ? "Cost - Rs." : "Income rate Rs.";
        const subKey = `${key}-${subTitle.toLowerCase().replace(" ", "_")}`;
        const subTag = `${tag}_calc`;
        const costOrIncome = isCost ? "cost" : "income";
        const typeTag = isRejected
          ? "rejected"
          : isYard
          ? "yard"
          : isExcavator
          ? "excavator"
          : null;

        const multiply_tags = [];
        if (typeTag) {
          multiply_tags.push(
            `volumes_${typeTag}`,
            `${costOrIncome}_${typeTag}`,
          );
        }

        if (!rowMap.has(subKey)) {
          const subRow = { ...row };
          subRow.editable = false;
          subRow.title = subTitle;
          subRow.tag = subTag;
          subRow.multiply_tags = multiply_tags;
          rowMap.set(subKey, subRow);
        }

        // Add total row if needed
        const totalRowKey = `${key}-total`;
        if ((isCost && isExcavator) || (!isCost && isExcavator)) {
          if (!rowMap.has(totalRowKey)) {
            // Add empty line
            const emptyRow = { ...row };
            emptyRow.editable = false;
            emptyRow.title = "";
            emptyRow.tag = "empty_line";
            emptyRow.months = {};
            rowMap.set(`${totalRowKey}_empty_line`, emptyRow);

            // Create total row
            const isCostTotal = isCost;
            const totalRow = { ...row };
            totalRow.isTotal = true;
            totalRow.editable = false;
            totalRow.title = isCostTotal
              ? "OTHER SUNDRY EXPS."
              : "HIRE OF EQUIPMENT (Income)";
            totalRow.tag = isCostTotal
              ? "other_sundry_calc"
              : "hire_of_equipment_income_calc";
            totalRow.sum_tags = [
              `${isCostTotal ? "cost" : "income"}_rejected_calc`,
              `${isCostTotal ? "cost" : "income"}_yard_calc`,
              `${isCostTotal ? "cost" : "income"}_excavator_calc`,
            ];
            rowMap.set(totalRowKey, totalRow);
          }
        }
      }

      row.sub_theme = subTheme.name;
    },
  });
}
